import { ITicker } from '@kattana-io/common';
import Text from '../../atoms/Text';
import { LivePrice } from './hooks/useTickerLivePrice';
import NumberDisplay from '../../molecules/NumberDisplay';
import { roundToPrecision } from '../../helpers/truncate';
import { getPriceChange } from '../../helpers/priceChange';

interface IDailyPriceChange {
  ticker: ITicker;
  price: LivePrice;
}

const DailyPriceChange = ({ ticker, price }: IDailyPriceChange) => {
  const { priceChange, priceChangePercent } = getPriceChange(
    price.rawPrice,
    ticker
  );

  // Return nothing if price didn't changed
  if (priceChange === 0) {
    return (
      <Text className='watchlist__row--neutral' size={10}>
        (0%) $0
      </Text>
    );
  }

  return (
    <Text
      className={`watchlist__row--${priceChangePercent < 0 ? 'red' : 'green'}`}
      size={10}
      style={{
        title: `(${roundToPrecision(
          priceChangePercent,
          true,
          4
        )}) ${roundToPrecision(priceChange, true, 4)}$`,
      }}
    >
      <NumberDisplay
        value={priceChangePercent}
        round={2}
        startSymbol='('
        endSymbol='%)'
        string
      />
      &nbsp;
      <NumberDisplay value={priceChange} round={2} startSymbol='$' string />
    </Text>
  );
};

export default DailyPriceChange;
